<template>
    <div class="picker moneyFill"
        :class="mustFlag">
        <h6><span></span>受骗金额</h6>
        <div class="text">
            <input 
                type="tel" 
                placeholder="请输入受骗金额"
                maxlength="14"
                v-model.trim="moneynum"
                @keyup="checkMoney"
                @change="getMess">
        </div>
    </div>
</template>

<script>
    export default {
        props: ["mustFlag"],
        data () {
            return {
                moneynum : ''
            }
        },
        methods:{
            // 校验输入金额，替换非数字字符
            checkMoney(){
                if(/[^\d]/.test(this.moneynum)){
                    let tempAmount = this.moneynum.replace(/[^\d]/g, '')
                    this.moneynum = tempAmount
                }
            },
            getMess(){
                this.$emit('transMess' , ['moneynum' , this.moneynum])
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/MoneyFill/MoneyFill.vue